import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/account-receivables/new/loading';

export const Route = createFileRoute('/_private/account-receivables/new')({
  pendingComponent: Loading,
});
